import bannerSlider from './sliders/bannerSlider/bannerSlider';

document.addEventListener('DOMContentLoaded', () => {
  const sliders = Array.prototype.slice.call(document.querySelectorAll('.js-banner-slider'));

  if (sliders.length) {
    sliders.forEach((el) => {
      bannerSlider(el);
    });
  }
});
